var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 2.43536C24.0802 2.8351 23.0916 3.10526 22.0541 3.22677C23.1131 2.60472 23.9264 1.61976 24.3093 0.44618C23.3183 1.02208 22.2206 1.44037 21.0523 1.66582C20.1167 0.689015 18.7837 0.0786133 17.3085 0.0786133C14.4758 0.0786133 12.1793 2.32891 12.1793 5.10448C12.1793 5.49839 12.2248 5.882 12.3122 6.24983C8.0494 6.04024 4.27009 4.03932 1.74037 0.998606C1.29888 1.74091 1.04594 2.60427 1.04594 3.52534C1.04594 5.269 1.95152 6.80737 3.32776 7.70863C2.48692 7.68256 1.69611 7.45648 1.00452 7.08004C1.00415 7.10101 1.00415 7.12207 1.00415 7.14321C1.00415 9.57837 2.77214 11.6098 5.11851 12.0714C4.68808 12.1863 4.23498 12.2477 3.76715 12.2477C3.43667 12.2477 3.11533 12.2162 2.80222 12.1575C3.45486 14.1543 5.34904 15.6074 7.59346 15.648C5.83809 16.9959 3.6265 17.7994 1.22353 17.7994C0.809558 17.7994 0.401258 17.7757 0 17.7293C2.26983 19.1553 4.96589 19.9873 7.86239 19.9873C17.2965 19.9873 22.4555 12.3289 22.4555 5.68728C22.4555 5.46936 22.4505 5.2526 22.4407 5.0371C23.4427 4.32849 24.3123 3.44326 25 2.43536Z",
    fill: "#55ACEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a715033ace702a816258ba3f0a78fa06.svg";
export { ForwardRef as ReactComponent };